import React from 'react';
import PropTypes from 'prop-types';

const Investing = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 114 114"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity=".2"
      d="M57 114c31.48 0 57-25.52 57-57S88.48 0 57 0 0 25.52 0 57s25.52 57 57 57z"
      fill="#B1E0E2"
    />
    <path
      d="M77.092 63.771h3.954c.926 0 1.71-1.496 1.674-3.313v-5.914c0-1.817-.783-3.277-1.745-3.277l-47.987.391c-.926 0-1.71 1.461-1.674 3.278v5.914c0 1.781.783 3.242 1.745 3.242l38.475-.285M79.159 64.342l-5.45 28.5a2.494 2.494 0 01-2.423 2.03l-29.747.25a2.494 2.494 0 01-2.458-2.102l-4.81-28.215M57.784 48.313c-3.955-22.194 16.637-19.06 16.637-19.06-.2 1.37-.33 2.75-.392 4.133-.499 16.85-11.97 12.255-15.818 14.606"
      stroke="#2061AE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57 50.873a15.105 15.105 0 012.921-7.125 29.392 29.392 0 017.125-8.123M54.007 42.357C60.562 17.17 36.48 19.023 36.48 19.023a35.64 35.64 0 010 4.738c-.855 19.451 12.825 15.176 16.957 18.204M56.037 51.476s0-11.828-13.822-27.04M51.907 82.828a3.99 3.99 0 004.346 3.563 3.918 3.918 0 004.275-3.563 3.883 3.883 0 00-4.31-3.384 3.99 3.99 0 01-4.347-3.563 3.918 3.918 0 014.275-3.562 3.92 3.92 0 014.418 3.562M56.145 69.892l.142 19.023"
      stroke="#2061AE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Investing.defaultProps = {
  className: '',
};

Investing.propTypes = {
  className: PropTypes.string,
};

export default Investing;
